import React from 'react';
import PropTypes from 'prop-types';

const SignalLegendItem = ({ signal, timestamp, handleSignalClick }) => {
    return (
        <button
            type='button'
            className={`signal-legend-label${signal.visible ? '' : ' hidden'}`}
            key={signal.userOptions?.id || signal.name}
            onClick={() => handleSignalClick(signal, timestamp)}
            aria-pressed={!!signal.visible}
        >
            <div className='signal-color-box' style={{ background: signal.color }} />
            <div>{signal.name}</div>
        </button>
    );
};

SignalLegendItem.propTypes = {
    signal: PropTypes.shape({
        visible: PropTypes.bool,
        userOptions: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }),
        name: PropTypes.string,
        color: PropTypes.string
    }).isRequired,
    timestamp: PropTypes.string.isRequired,
    handleSignalClick: PropTypes.func.isRequired
};

export default SignalLegendItem;
